import { StepType } from 'src/app/shared/shared.module';
import {
  getInputField, setAsRequired, setRegexValidation,
  getSelectField, getTypeAheadField, getDateField,
  setAsRequiredEmail, setDisableWhen, setRequiredWhen,
  MinMaxAgeMustBe, getTypeAheadSelectField, setDisablewithValueWhen, getRadioButton,
  setAsDisabled, getTelephoneField
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { isNullOrUndefined } from '../../../../../../app/core/utils';
import { FieldTooltip } from './../../field-tooltip.enum';
import { map } from 'rxjs/operators';

export class BusinessVisa extends VisaType {
  GetRequesterSteps(operations?: () => string[]): StepType[] {
    return [
      {
        label: "Step 1",
        fields: [
          // {
          //     fieldGroupClassName: "row",
          //     fieldGroup: [
          //         getButtonCombo("gui",
          //             "GUI", setAsRequired())
          //     ]
          // },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "currentEyEmployee.id",
                "Is traveller a current EY employee?",
                this.common.getSelectFieldOptions(this.yesNo$, '',
                  setAsRequired())
              ),
              this.EmpProfileSearch(
                setDisableWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id !== 1074)
                , operations)
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.nonMandatoryGpn(
                setDisablewithValueWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id !== 1074,
                  setRequiredWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id === 1074)
                )
              ),
              this.nonMandatoryGui(
                setDisablewithValueWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id !== 1074,
                  setRequiredWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id === 1074)
                )
              ),
              // this.gpnGuiSearchButton(operations)
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.firstName(),
              this.middleName(),
              this.lastName()
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField(
                "newJoinerNameInArabic",
                "Name in Arabic",
                this.addFieldTooltipWithAdditionalConfig('Name in Arabic')
            ),
            this.nationalityTypeWithSpecialExpact(),  
            // getSelectField("nationalityType.id", "Nationality type",
            // this.common.getSelectFieldOptionsWithDisable(this.nationalityType$.pipe(map(item => item.filter(i => 
            // [14570,14571,14572,14573].includes(i.id)))), [14573],setAsRequired())), 
          //removed the disabling as this can cause deadlock. take example of a employee with no le in empprof and then emp selects a wrong le, this will cause the le to be non editable
            this.nationality()
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.passportNumber(
              ),     
              this.passportType(               
              ),
              this.passportExpiryDate('Passport expiry date'),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future'                
              )),
              this.placeOfBirth(),
              this.gender(),

              this.emailAddress(),
              getSelectField(
                "serviceLine.id",
                "Service line",
                this.common.getSelectFieldOptions(this.serviceLines$, '',
                  setDisablewithValueWhen((model) => model.menaEmployee == 1 && !isNullOrUndefined(model.serviceLine.id), setAsRequired(), true))
              ),
              getSelectField(
                "subServiceLine.id",
                "Sub-service line",
                this.common.getSelectFieldOptionswithValue(this.subServiceLines$, "serviceLine.id",
                  setDisablewithValueWhen((model) => model.menaEmployee == 1 && !isNullOrUndefined(model.subServiceLine.id), setAsRequired(), true))
              ),
              this.rank(
                setDisablewithValueWhen((model) => model.menaEmployee == 1 && !isNullOrUndefined(model.job) && !isNullOrUndefined(model.job.rank),
                  setRequiredWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id === 1074
                  ), true)
              ),
              // getSelectField(
              //   "officeLE.id",
              //   "EY KSA Legal entity name",
              //   this.common.getSelectFieldOptionsWithSL(this.officeLE$, '', setAsRequired()
              //   )
              // ),
              this.officeLE('EY Legal entity'),
              this.ksaOfficeLocation()
            ]
          }
        ]
      },
      {
        label: "Step 2",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              //this.grade(),
              // this.allEmployeeCurrentLocation(setDisableWhen((model) => (!isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id !== 1074),
              //   setRequiredWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id === 1074,
              //     this.AddTooltipToControl(FieldTooltip.KSABusinessVisaOfficeLocation)
              //   )
              // )),
              // getSelectField(
              //   "employeeCurrentLocationCountry.id",
              //   "Current office location",
              //   this.common.getSelectFieldOptions(this.nationality$, '',
              //     setDisableWhen((model) => (!isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id !== 1074),
              //       setRequiredWhen((model) => !isNullOrUndefined(model.currentEyEmployee) && model.currentEyEmployee.id === 1074,
              //         this.AddTooltipToControl(FieldTooltip.KSABusinessVisaOfficeLocation)
              //       )
              //     ))
              // ),
              this.currentOfficeLocation(),
              getSelectField("travelType.id", "Travel type",
                this.common.getSelectFieldOptions(this.travelType$, '',
                  setAsRequired(
                    this.common.isTravellerInterMena(setAsDisabled())
                  ))),
              getTelephoneField(
                "Employee phone number",
                setAsRequired(),
                'col-md-4  pr-0 '),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              // getSelectField(
              //   "religion.id",
              //   "Religion",
              //   this.common.getSelectFieldOptions(this.religion$.pipe(map(x => x.filter(l => ![6628].includes(l.id)))), '',
              //     setAsRequired())
              // ),
              this.Religion(),
              getSelectField(
                "currentGccResident.id",
                "Is traveller a current GCC resident?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsRequired())
              ),
              getInputField(
                "nonGCCResidencyTitle",
                "Job title (non-GCC residents)",
                setDisableWhen((model) =>
                  !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id !== 1075,
                  setRequiredWhen((model) =>
                    !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1075)
                )
              ),
              this.jobTitleGCCResident(),
              getInputField(
                "gccSponsorName",
                "GCC Visa Sponsor name (for GCC residents only)",
                this.common.isAccessible()
              ),
              getSelectField(
                "entryType.id",
                "Visa entry type",
                this.common.getSelectFieldOptions(this.entryType$.pipe(map(x => x.filter(l => [5916,5917].includes(l.id)))), '',
                  setAsRequired())
              ),
              getSelectField(
                "durationOfStay.id",
                "Duration of stay (how long will you need to be in KSA?)",
                this.common.getSelectFieldOptions(
                  this.common.getDurationOfStay(5899),
                  'entryType.id',
                  setAsRequired({ className: 'col-md-4 mb-3 text-sm lengthy-label' }))
              )
            ]
          }
        ]
      },
      {
        label: "Step 3",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              // getSelectField(
              //   "embassy.id",
              //   "Embassy/Consulate (country)",
              //   this.common.getSelectFieldOptions(this.nationality$, '',
              //     setAsRequired(this.AddTooltipToControl(FieldTooltip.KSABusinessVisaEmbassyConsulate)))
              // ),
              this.embassyConsulateCountry(),
              // getInputField(
              //   "cityOfEmbassy",
              //   "Embassy/Consulate (city)",
              //   setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/,
              //     'Please enter a valid name', this.AddTooltipToControl(FieldTooltip.KSABusinessVisaEmbassyConsulate)))
              // ),
              this.embassyConsulateCity(),
              getInputField(
                "chargeCode",
                "Charge code",
                this.addFieldTooltipWithAdditionalConfig('Charge code',this.common.ValidateChargeCode(
                  '',
                  setAsRequired()), true)
              ),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
             
              // getInputField(
              //   "engagementName",
              //   "Engagement name"),
              // getInputField(
              //   "engPartnerName",
              //   "Engagement partner name"),
              this.travelDate(),
              this.exitDate(),
              // getInputField(
              //   "reason",
              //   "Reason for visit",
              //   setAsRequired(
              //     this.AddTooltipToControl(FieldTooltip.KSABusinessVisaVisitReason)
              //   )
              // ),
              this.reasonForVisit(),
              getInputField(
                "projectName",
                "Project Name"
              ),
              // getDateField(
              //   "dateOfExit",
              //   'Date of exit',
              //   setAsRequired(
              //     setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              //       "Please enter a valid date in 'dd-mm-yyyy' format",
              //       this.common.AcceptDateAfter(0, "Date of exit cannot be a past date", "Date of exit", true)
              //     )
              //   )),

              // getTypeAheadField(
              //   "projectManager",
              //   "Project partner/ Manager"),

              this.RequestorName()]
          },
        ]
      }
    ];

  }

  GetAccepterSteps(): StepType[] {
    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              //this.visaProcessorByOfficeLE(setAsRequired()),
              // this.Requestor()
              this.visaProcessorByOLE()
            ]
          }
        ]
      }
    ];
  }

  GetApproverSteps(): StepType[] {

    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              // this.visaProcessorByOfficeLE(
              //   setAsRequired()
              //   ),
              this.visaProcessorByOLE(),
              this.immigrationStatus(setAsRequired()),
              getInputField(
                "loiNumber",
                "LOI number"
                ,setAsRequired()
            ),
            getDateField("loiIssueDate", "LOI issue date", 
            setAsRequired(
              setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                "Please enter a valid date in 'dd-mm-yyyy' format")
                )
            ),
            // getInputField(
            //   "loiVisaDuration",
            //   "LOI visa duration"
            //   ,setAsRequired()
            // ),
            // getInputField(
            //   "loiVisaType",
            //   "LOI visa type"
            //   ,setAsRequired()
            // ),
            getInputField(
              "loiJobTiteInArabic",
              "LOI job title (English)"
              ,setAsRequired()
            ),
            getInputField("sponsorID","Sponsor ID" ,setAsRequired(this.common.SponsorIDvalidate()))
              // this.Requestor()
            ]
          }
        ]
      }
    ];
  }

  filterForOfficeToBeVisited(value) {
    if (value == 704) {   //EYSP (Saudi Arabia )
      return [663, 668] //Jeddah Riyadh
    }
  }
  

}
